import React, { createContext, useContext, useEffect, useState, useCallback, useMemo } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = loading
  const [authed, setAuthed] = useState(false);

  const refresh = useCallback(async () => {
    const token = localStorage.getItem("vc_token");
    if (!token) {
      setUser(null);
      setAuthed(false);
      return null;
    }
    try {
      const { data } = await api.get("/auth/me");
      setUser(data.user);
      setAuthed(true);
      return data.user;
    } catch (e) {
      localStorage.removeItem("vc_token");
      setUser(null);
      setAuthed(false);
      return null;
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const loginWith = useCallback((token, u) => {
    localStorage.setItem("vc_token", token);
    setUser(u);
    setAuthed(true);
  }, []);

  const logout = useCallback(() => {
    localStorage.removeItem("vc_token");
    setUser(null);
    setAuthed(false);
  }, []);

  const value = useMemo(
    () => ({
      user,
      authed,
      loading: user === null && localStorage.getItem("vc_token"),
      refresh,
      loginWith,
      logout,
    }),
    [user, authed, refresh, loginWith, logout]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export const useAuth = () => useContext(AuthContext);
